import { render } from "./SVGShelfSeparatorDropdown.vue?vue&type=template&id=b6190fec"
import script from "./SVGShelfSeparatorDropdown.vue?vue&type=script&lang=js"
export * from "./SVGShelfSeparatorDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__